import "./style/style2.css"
import { useState, useEffect } from 'react';

import { Link } from 'react-router-dom';

import ImageSlider from './ImageSlider'

import arrowIcon from './images/arrow.svg'
import ScrollToTop from './ScrollToTop';
import ProjectNav from "./Project_Nav";
import Footer from './Footer';

import folioMultiProjects from './images/UX-UI-Project-Web-App-Dashboards.png'

import CardiolyaImg1 from './images/Other-Projects/11 Cardiolya FItness Dashboard.png';
import CardiolyaImg2 from './images/Other-Projects/12 Cardiolya FItness Activities.png';
import CardiolyaImg3 from './images/Other-Projects/13 Cardiolya FItness Profile.png';

import PogondoEcomUX1 from './images/Other-Projects/22_1 Dashboard Ecom 1_2.png';
import PogondoEcomUX2 from './images/Other-Projects/22_2 Dashboard Ecom 1_2 – Dark Mode.png';
import PogondoEcomUX3 from './images/Other-Projects/22_2 Dashboard Ecom Schedule.png';
import PogondoEcomUX4 from './images/Other-Projects/22_3 Dashboard Ecom Store.png';


import SEOMashUX1 from './images/Other-Projects/33 SEO Mash Dashboard.png';
import SEOMashUX2 from './images/Other-Projects/33_2 SEO Mash Targetting.png';
import SEOMashUX3 from './images/Other-Projects/33_3 SEO Mash Analytics.png';

export default function ProjectsMultiple() {

    const [TransY, setTransY] = useState('translateY(333px)');
    const [OpacityB, setOpacityB] = useState('0.0');

    {/* SLIDER JS*/ }

    const slidesP1 = [

        { url: CardiolyaImg1, alt: 'Health-App-Dashboard-UX-UI-Design-1' },
        { url: CardiolyaImg2, alt: 'Health-App-Dashboard-UX-UI-Design-2' },
        { url: CardiolyaImg3, alt: 'Health-App-Dashboard-UX-UI-Design-3' }
    ]
    const slidesP2 = [

        { url: PogondoEcomUX1, alt: 'Ecommerce-App-Dashboard-UX-UI-Design-1' },
        { url: PogondoEcomUX2, alt: 'Ecommerce-App-Dashboard-UX-UI-Design-2' },
        { url: PogondoEcomUX3, alt: 'Ecommerce-App-Dashboard-UX-UI-Design-3' },
        { url: PogondoEcomUX4, alt: 'Ecommerce-App-Dashboard-UX-UI-Design-4' }
    ]
    const slidesP3 = [

        { url: SEOMashUX1, alt: 'SEO-App-Dashboard-UX-UI-Design-1' },
        { url: SEOMashUX2, alt: 'SEO-App-Dashboard-UX-UI-Design-2' },
        { url: SEOMashUX3, alt: 'SEO-App-Dashboard-UX-UI-Design-3' }
    ]


    useEffect(() => {
        // This will be called after the initial render
        setOpacityB('1');
        setTransY('translateY(0px)');
    }, []);



    return (
        <ScrollToTop>
            {/*<motion.div initial= {{y: 333, opacity:0}} animate= {{y: 0, opacity:1}} exit= {{opacity: 0}} transition = {{ duration: 1, ease: [0.22, 1, 0.36, 1]}}>*/}

            <div class="projectPage">

                {/* Navigation Arrows */}
                <div style={{ position: 'fixed', top: '13px', left: '13px', 'z-index': '55', opacity: OpacityB }}>
                    <div style={{ position: 'absolute', transform: 'rotate(-134deg)' }}>
                        <Link to="/" style={{ 'text-decoration': 'none' }}>
                            <div class='iconCircle'><img src={arrowIcon} style={{ margin: '0px', transform: 'translate(-2px,-3px)' }} /></div>
                        </Link>
                    </div>
                </div>
                <div style={{ position: 'fixed', bottom: '67px', right: '67px', 'z-index': '55', opacity: OpacityB }}>
                    <div style={{ position: 'absolute', transform: 'rotate(-45deg)' }}>
                        <a href="#top" style={{ cursor: 'default' }}>
                            <div class='iconCircle'><img src={arrowIcon} style={{ margin: '0px', transform: 'translate(-1px,-2px)' }} /></div>
                        </a>
                    </div>
                </div>

                <div className="bar" style={{ opacity: OpacityB }}><img src={folioMultiProjects} style={{ opacity: OpacityB }}></img></div>


                {/* <img src={folioOdenlo} style={{ opacity: OpacityB, transform: "translateY(37px)" }} /> */}

                <div className="bar2" style={{ 'background-color': '#222', transform: TransY, opacity: OpacityB, position: 'sticky', top: 0 }}>
                    <div class="projectHeader">
                        <div class="textBoxLeft">
                            <div class="smallText">Client:</div>
                            <div class="projectTitle">Multiple Clients<br /></div>
                        </div>
                        <div class="projectTitleRight">
                            <div class="smallText">Summary</div>
                            <div class="projectTitle">A selection of UI Designs from past projects</div>

                        </div>
                    </div>

                    <div class="projectHeader">
                        <div class="textBoxLeft">
                            <div class="smallText">Role:</div>
                            <div class="projectTitle">UX UI Developer </div>
                        </div>
                        <div class="projectTitleRight">
                            <div class="smallText">Tools</div>
                            <div class="projectTitle">Figma, JS, CSS</div>
                        </div>
                    </div>
                </div>

                <div class="Rido" style={{ top: '0px', 'background-color': '#ffffff', opacity: '1', 'z-index': '-2' }}></div>


                <div class="ProjectContainer" style={{ transform: TransY, opacity: OpacityB }}>
                    <div class="section">
                        <div class="oneColumnIntro">
                            <h2>Introduction</h2>
                            <div class="IntroTexts"> The following are a selection of UI Designs I did in the past for different clients.</div>
                        </div>
                    </div>

                    {/*<div class="totalWidth"><ColoredLine color="#3d3d3d" /></div>*/}

                    <div class="oneThirdSection">

                        <div class="smColumn">

                            <h2>Cardiolya</h2>

                            {/* Cardiolya is a Health tracking app. Users are able to track their calorie */}

                            <p>Cardiolya is <strong>a health and fitness tracking app</strong> designed to help users monitor their daily activities, nutrition, and fitness goals. The dashboard provides a personalized overview of the user's progress, including step counts, workout schedules (such as boxing and tennis), and monthly objectives like water intake and weight loss. It also tracks recent activities with details on duration, calories burned, and timestamps.
                            </p>
                        </div>

                        <div class="bigColumn">
                            <ImageSlider slides={slidesP1} />
                        </div>

                    </div>

                    <div class="oneThirdSection">

                        <div class="smColumn">



                            <h2> 'Pogondo' E-Commerce Platform</h2>

                            <p>
                                This is the dashboard of an E-com platform. It serves as an <strong>analytics tool for e-commerce</strong>, offering insights into sales performance, inventory, and product trends. It displays key metrics such as revenue growth, ad spend efficiency, and stock levels (e.g., Nike Air Max availability). The interface includes visualizations for yearly sales trends, popular products, and real-time updates on product status (active/inactive). 
                            </p>

                        </div>

                        <div class="bigColumn">
                            <ImageSlider slides={slidesP2} />
                        </div>
                    </div>


                    <div class="oneThirdSection">

                        <div class="smColumn">

                            <h2>'Mash SEO' SEO Marketing Tool</h2>

                            <p>SEO Mash is a<strong> search engine optimization (SEO) analytics platform </strong>that tracks website performance, traffic sources, and site health. The dashboard provides a session overview with trends over the last 12 days, breaking down traffic by device (mobile vs. desktop) and sources (social media, organic search, direct visits).</p>


                        </div>

                        <div class="bigColumn">
                            <ImageSlider slides={slidesP3} />

                        </div>

                    </div>
                </div>

                <ProjectNav NextProject='/project-odenlo' PrevProject='/project-fleet' />

                <Footer />
            </div>


        </ScrollToTop >
    )

}
